import React from 'react';
import * as api from '../../../services/api';
import * as MRSStatus from '../../../constants/MRSStatus';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getBranchIds, getBranchRouteNumbers } from '../../../utils/api-util';
import { injectIntl } from 'react-intl';
import PortalPage from '../../presenters/ManagedRestroomServices/PortalPage/PortalPage';
import { DEFAULT_PAGEABLE } from '../../../services/_api/shared';
import { DEFAULT_DIRECTION, DIRECTION } from '../../../constants/constants';
import { MRS_ORDER_APPROVE_URL } from '../../../route-names';
import { canApproveOrders } from '../../../utils/mrs-util';

class ManagedRestroomServices extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      mrsRequiringActionCount: 0,
      mrsOrdersRequiringAction: [],
      sortBy: {
        name: 'order.modifiedDate',
        direction: DIRECTION.desc.name
      },
      page: DEFAULT_PAGEABLE.page
    };

    this._isMounted = false;
    this.updateState = this.updateState.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateState();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.appStore.activeBranchId !== prevProps.appStore.activeBranchId
    ) {
      this.updateState();
    }
  }

  updateState() {
    const { activeBranchId, branches, routes } = this.props.appStore;
    const branchIds = getBranchIds(activeBranchId, branches);
    const allowedRoutes = routes.filter((route) =>
      branchIds.includes(route.branchId)
    );

    const branchRouteNumbers = getBranchRouteNumbers(null, allowedRoutes);

    if (branchIds.length > 0 && branchRouteNumbers.length > 0) {
      Promise.all([
        api.mrsOrders.count({
          statuses: [MRSStatus.APPROVAL_REQUIRED.name],
          branchIds,
          branchRouteNumbers
        }),
        api.mrsOrders.get({
          statuses: [MRSStatus.APPROVAL_REQUIRED.name],
          branchIds,
          branchRouteNumbers
        })
      ])
        .then((values) => {
          const [mrsRequiringActionCount, mrsOrdersRequiringAction] = values;

          if (this._isMounted) {
            this.setState({
              loading: false,
              mrsRequiringActionCount: mrsRequiringActionCount.data,
              mrsOrdersRequiringAction: mrsOrdersRequiringAction.data.content,
              page: {
                size: mrsOrdersRequiringAction.data.size,
                totalElements: mrsOrdersRequiringAction.data.totalElements,
                number: mrsOrdersRequiringAction.data.number,
                numberOfElements: mrsOrdersRequiringAction.data.numberOfElements
              }
            });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false });
    }
  }

  handleRequestSort = (name) => {
    const direction =
      this.state.sortBy.name === name
        ? DIRECTION[this.state.sortBy.direction].opposite
        : DEFAULT_DIRECTION;

    this.setState(
      {
        sortBy: {
          name,
          direction
        }
      },
      this.updateCurrentState
    );
  };

  handleChangeRowsPerPage(rows) {
    this.setState(
      {
        page: {
          size: rows,
          numberOfElements: rows,
          totalElements: this.state.page.totalElements,
          number: 0
        }
      },
      this.updateCurrentState
    );
  }

  handleChangePage(number) {
    this.setState(
      {
        page: {
          ...this.state.page,
          number
        }
      },
      this.updateCurrentState
    );
  }

  updateCurrentState(doResetPage = false) {
    this.setState({
      page: doResetPage ? DEFAULT_PAGEABLE.page : this.state.page,
      customers: []
    });
  }

  handleOrderClick = (id) => {
    this.props.history.push(MRS_ORDER_APPROVE_URL.replace(':orderId', id));
  };

  render() {
    return (
      <PortalPage
        loading={this.state.loading}
        mrsRequiringActionCount={this.state.mrsRequiringActionCount}
        mrsOrdersRequiringAction={this.state.mrsOrdersRequiringAction}
        page={this.state.page}
        sortBy={this.state.sortBy}
        handleRequestSort={this.handleRequestSort}
        handleChangePage={this.handleChangePage}
        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        handleOrderClick={canApproveOrders() ? this.handleOrderClick : null}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default injectIntl(
  withRouter(connect(mapStateToProps)(ManagedRestroomServices))
);
